import { gql } from '@apollo/client';
import {
  Button,
  CardSection,
  CardSectionControl,
  CardSectionDescription,
  CardSectionTitle,
  Group,
} from '@apollo/orbit';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { LazyUrlModal } from 'src/components/common/LazyUrlModal';
import { PermissionWarning } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';
import { Config } from 'src/lib/config/config';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { setOverlayVisibleLocation } from 'src/lib/routing';

import { ReApprovalRequirementsModal } from '../approvalsAndPermissionsCard/reapprovalRequirementsModal/ReApprovalRequirementsModal';

export const ReApprovalRequirementsSectionServiceFragment = gql`
  fragment ReApprovalRequirementsSectionServiceFragment on Service {
    id
    proposalsMustBeReApprovedOnChange
  }
`;

export const ReApprovalRequirementsSection = ({
  graph,
}: {
  graph: GraphQLTypes.ReApprovalRequirementsSectionServiceFragment;
}) => {
  const location = useLocation();

  return (
    <>
      <CardSection className="flex-row">
        <Group orientation="vertical">
          <CardSectionTitle>Approvals withdrawn on change</CardSectionTitle>
          <CardSectionDescription>
            {graph.proposalsMustBeReApprovedOnChange ? (
              <>
                If a proposal is revised after being approved, approvals will be
                withdrawn and reviews will be re-requested.
              </>
            ) : (
              <>
                If a proposal is revised after being approved, the proposal
                stays approved.
              </>
            )}
          </CardSectionDescription>
        </Group>
        <CardSectionControl>
          <PermissionWarning
            graphId={graph.id}
            graphPermissions="canManageProposalPermissions"
            childRenderer={(hasPermission) => (
              <Button
                variant="secondary"
                isDisabled={!hasPermission}
                as={Link}
                to={setOverlayVisibleLocation({
                  location,
                  overlayName: Config.modals.editReApprovalRequirementOnChange,
                })}
              >
                Manage approval requirements
              </Button>
            )}
          />
        </CardSectionControl>
      </CardSection>
      <LazyUrlModal name={Config.modals.editReApprovalRequirementOnChange}>
        {({ closeModal, isOpen }) => (
          <ReApprovalRequirementsModal
            isOpen={isOpen}
            onClose={closeModal}
            proposalsMustBeReApprovedOnChange={
              graph.proposalsMustBeReApprovedOnChange
            }
          />
        )}
      </LazyUrlModal>
    </>
  );
};
